export default __webpack_public_path__ + "static/media/default.a392e65542d681b098a9b17c87703b6a.png";